
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projetos",
      function () {
        return require("private-next-pages/projetos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projetos"])
      });
    }
  